import { useMutation } from '@tanstack/react-query';

import { freemiumApi } from '@client/api/waterlily';

import type { FreemiumIntentId } from '@shared';

// Captures an unlocked advisor's free-text intent (comprehensive-plan /
// something-else) so it reaches the team — reuses the selection endpoint, which
// records the request and emails the team when there is no tier to charge.
export function useFreemiumIntentCapture(clientId: string) {
  return useMutation({
    mutationFn: ({ intent, details }: { intent: FreemiumIntentId; details: string }) =>
      freemiumApi.postSelection(clientId, { intent, details: details.trim() }),
  });
}
